import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  history: string[]

  unsubber$: Subject<any> = new Subject()
  previousRoute: string = '';
  appPrevRoute: string[] = [];

  get lastRoute() {
    return this.history[this.history.length - 2]
  }

  get _hasHistory() {
    /** 
     * This assumes all user is using Chrome and Chrome stores landing page as part of history
     * Further explanation: https://stackoverflow.com/a/48762917
     */
    return window.history.length > 1
  }

  constructor(private router: Router, private location: Location, private route: ActivatedRoute) { }

  /**
   * This has to be called once, by App component
   */
  initService() {
    this.history = []
    this.router.events
      .pipe(takeUntil(this.unsubber$.asObservable()))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          const url = event.urlAfterRedirects
          this.history.push(url)
        }
      })
    
  }

  stopNav() {
    this.unsubber$.next()
    this.unsubber$.unsubscribe()
  }

  back(): void {
    
    this.previousRoute = this.history.pop()
    if (this._hasHistory && this.history.length) {
      this.location.back()
    }
    /** This is fallback in case history logic fails */
    else {
      this.router.navigateByUrl('/')
    }
  }

  /**
   * START:SCBT - SIMULATE CLOSE BUTTON FEATURE
   * - Simulates close button for component with multiple same route
   * - Eg: See Tables Component
   * 
   * SETUP GUIDE:
   * - In the parent route component's oninit, initialize @function simulCloseOnInit() with route to ignore
   * - Blacklist param will be the routes to ignore (eg: 'tables')
   * - Close button must be in parent component
   * - When close button is clicked, call @function simulateClose()
   */

  /**
   * Simulate Close blacklist route
   * The valid route stored as reference to check
   */
  private _blistRoute: string
  /** Simulate Close's previous route, filtered by validRoute */
  private _sClosePrevRoute: string = ''

  private get sClosePrevRoute() {
    if (!this._blistRoute) return ''

    const _sClosePrevRoute = this.lastRoute?.includes(this._blistRoute) ? this._sClosePrevRoute : this.lastRoute;
    return _sClosePrevRoute
  }

  /**
   * Register simulate close route to ignore
   */
  simulCloseOnInit(blistRoute: string) {
    this._blistRoute = blistRoute
    this._sClosePrevRoute = this.sClosePrevRoute
  }

  /**
   * Simulates close button
   * Call this from any component to simulate close, navigating to previous non-blacklisted route
   */
  simulateClose() {
    if (this.sClosePrevRoute)
      this.router.navigate([this.sClosePrevRoute])
    else
      this.back()
  }
  /**
   * END:SCBT - SIMULATE CLOSE BUTTON FEATURE
   */
}
